<template>
  <div>
    <loadingCube v-if="!loading_worker" :loadingMessage="'WORKER'"></loadingCube>
    <div v-else class="record">
      <div class="row">
        <div class="col-md-4">
          <h2 class="font-weight-bold bp_color mb-0">{{ full_name }}</h2>
          <h3 v-if="worker.rel_profile.job_title_id !== null">{{ worker.rel_profile.job_title.job_title }}</h3>
        </div>
        <div class="col-md-8">
          <div class="record_short_btns">
            <div class="row">
              <!-- Office 3655 -->
              <div class="col-4 text-left">
                <!--              <button @click="createEmail" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1 disabled" disabled data-toggle="tooltip" title="Send Email">-->
                <!--                <i class="fas fa-paper-plane"></i>&nbsp;Email-->
                <!--              </button>-->
                <!--              <button @click="createEvent" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1 disabled" disabled data-toggle="tooltip" title="Create Event">-->
                <!--                <i class="fas fa-calendar-plus"></i>&nbsp; Event-->
                <!--              </button>-->
                <!--              <button @click="createTask" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1 disabled" disabled data-toggle="tooltip" title="Create Task">-->
                <!--                <i class="fas fa-plus-square"></i>&nbsp;Task-->
                <!--              </button>-->
              </div>
              <!-- Quick Action Buttons -->
              <div class="col-8">
                <button @click.prevent="export_worker" class="btn orcaBtn sm_btn warning mb-2 mr-1 ml-1" :disabled="worker_export">
                  <span v-if="!worker_export"><i class="fas fa-download"></i>&nbsp;Export Worker</span>
                  <span v-else-if="worker_export"><i class="fas fa-spinner fa-pulse"></i> &nbsp; Exporting</span>
                </button>
                <button v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager') || $store.state.auth.me.roles.includes('accounts'))
              && !in_ac_export" @click="add_to_finance_export_accounts" class="btn orcaBtn sm_btn purpleBtn mb-2 mr-1 ml-1" data-toggle="tooltip"
                    title="Add worker to accounts export">
                  <i class="fas fa-leaf"></i>&nbsp;A
                </button>
                <button v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager') || $store.state.auth.me.roles.includes('accounts'))
              && !in_p_export" @click="add_to_finance_export_payroll" class="btn orcaBtn sm_btn purpleBtn mb-2 mr-1 ml-1" data-toggle="tooltip"
                    title="Add worker to payroll export">
                  <i class="fas fa-leaf"></i>&nbsp;P
                </button>
                <button v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager') || $store.state.auth.me.roles.includes('accounts'))
              && !in_t_export" @click="add_to_finance_export_tax" class="btn orcaBtn sm_btn purpleBtn mb-2 mr-1 ml-1" data-toggle="tooltip" title="Add worker to payroll export">
                  <i class="fas fa-leaf"></i>&nbsp;T
                </button>
                <br>
                <button @click="show_edit_worker" class="btn orcaBtn sm_btn blueBtn mb-2 mr-1 ml-1" data-toggle="tooltip" title="Edit Worker">
                  <i class="fas fa-user-edit"></i>
                </button>
                <!-- <button v-if="!worker.new_starters.verified_at && !worker_reg_verified" 
                    @click="verify_worker" class="btn orcaBtn sm_btn greenBtn mb-2 mr-1 ml-1" data-toggle="tooltip"
                    title="Verify Worker Login"><i class="fas fa-check-circle"></i></button> -->
                <button @click="delete_worker" v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager'))"
                    class="btn orcaBtn sm_btn danger mb-2 mr-1 ml-1" data-toggle="tooltip" title="Delete Worker"><i class="fas fa-trash-alt"></i></button>
                <button @click="add_note_modal" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1" data-toggle="tooltip" title="Add Notes for Worker">
                  <i class="fas fa-comment-dots"></i>&nbsp; add note
                </button>
                <button @click="add_files_modal" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1" data-toggle="tooltip" title="Upload Worker Files">
                  <i class="fas fa-file-upload"></i> &nbsp;Upload File
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-tabs v-model="worker_profile_tabIndex" pills vertical>
        <template v-slot:tabs-start>
          <div class="record_info" style="max-width: 255px">
            <p class="b3_color mb-0" v-if="worker.rel_company_info.employment_type_id !== null"><strong><i class="fas fa-info"></i></strong> {{
                worker.rel_company_info.employment_type.value
              }}</p>
            <p class="b3_color mb-0" v-if="worker.rel_company_info.company_internal_finance_ref !== null"><strong>C</strong>
              <span>{{ worker.rel_company_info.company_internal_finance_ref }}</span>
            </p>
            <p class="b3_color mb-0" v-if="worker.rel_company_info.historical_internal_finance_ref !== null"><strong>HC</strong>
              <span><s>{{ worker.rel_company_info.historical_internal_finance_ref }}</s></span>
            </p>
            <p class="b3_color mb-0"><strong>W</strong>
              <span>{{ worker.internal_finance_ref }}</span>
            </p>
            <hr>
            <div v-if="emails.website_login !== null">
              <strong><i class="fas fa-at"></i></strong>
              <a :href="'mailto:' + emails.website_login.email_address" class="email_link">{{ emails.website_login.email_address }}</a>
            </div>
            <hr>
            <div v-if="phones.personal_landline !== null"><strong><i class="fas fa-mobile-alt"></i></strong>{{ phones.personal_landline.phone_number }}</div>
            <div v-if="phones.personal_mobile !== null"><strong><i class="fas fa-phone-alt"></i></strong>{{ phones.personal_mobile.phone_number }}</div>
            <div v-if="addresses.home !== null"><strong><i class="fas fa-home"></i></strong>
              <span class="d-inline-block" style="width: calc(100% - 40px);vertical-align: top;">{{ addresses.home.full }}</span>
            </div>
            <div><strong>NI</strong>{{ worker.rel_profile.ni_number }}</div>
            <div v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id !== 33"><strong>UTR</strong>{{
                worker.rel_profile.personal_utr_number }}</div>
            <!-- Limited INFO -->
            <hr v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id === 32">
            <h5 v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id === 32" style="font-size: 0.85rem; margin-bottom: 3px;"><i class="fas fa-building"></i> &nbsp; LTD Company</h5>
            <div v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id === 32">
              <strong>TN</strong>{{ worker.rel_company_info.company_trading_name }}
            </div>
            <div v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id === 32">
              <strong>LTD</strong>{{ worker.rel_company_info.company_ltd_reg_number }}
            </div>
            <div v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id === 32">
              <strong>UTR</strong>{{ worker.rel_company_info.company_utr_number }}
            </div>
            <hr v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id !== 33">
            <div v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id !== 33 && notEmptyObject(cis_status) && cis_status.cis_response !== null">
              <div class="cis_status" :class="cis_status_class">
                <div class="cs_head">CIS TAX STATUS</div>
                <div class="cs_body">
                  <span v-if="cis_status.cis_response.worker_status === 'matched'">
                    <span class="d-inline-block mr-2">MATCHED</span>
                    <span class="perc" :class="cis_perc_class" v-if="cis_status.cis_response.tax_treatment === 'gross'">0%</span>
                    <span class="perc" :class="cis_perc_class" v-else-if="cis_status.cis_response.tax_treatment === 'net'">20%</span>
                  </span>
                  <span v-else-if="cis_status.cis_response.worker_status === 'unmatched'">
                    <span class="d-inline-block mr-2">UNMATCHED</span>
                    <span class="perc" :class="cis_perc_class">30%</span>
                  </span>
                </div>
              </div>
            </div>
            <div v-else-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id !== 33">
              <div class="cis_status" :class="cis_status_class">
                <div class="cs_head">CIS TAX STATUS</div>
                <div class="cs_body">
                  <span>NOT VERIFIED</span>
                </div>
              </div>
            </div>
            <hr class="mb-0">
          </div>
        </template>
        <!-- Dashboard -->
        <b-tab title="Dashboard / Notes" lazy>
          <b-card-text>
            <dashboard v-if="notEmptyObject(worker)" :worker="worker" :tax_hmrc="tax_hmrc" :files="files" :notes="notes" :notesLoaded="notes_loaded"
                @update_tab="update_tab_index"/>
          </b-card-text>
        </b-tab>
        <!-- Profile -->
        <b-tab title="Personal Info" lazy>
          <b-card-text>
            <personal_info v-if="notEmptyObject(worker)" :worker="worker" :emails="emails" :phones="phones" :addresses="addresses" :banks="banks"/>
          </b-card-text>
        </b-tab>
        <!-- Business Info -->
        <b-tab title="Business Info" lazy v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id !== 33">
          <b-card-text>
            <business_info v-if="notEmptyObject(worker)" :worker="worker" :emails="emails" :phones="phones" :addresses="addresses" :banks="banks"/>
          </b-card-text>
        </b-tab>
        <!-- Tax verification -->
        <b-tab title="CIS Verification" lazy v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id !== 33">
          <cis_verification :worker="worker" :cis_status="cis_status" :cis_loaded="cis_loaded"></cis_verification>
        </b-tab>
        <!-- Compliance Tests -->
        <b-tab title="Compliance Tests" lazy v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id !== 33">
          <compliance_tests :worker="worker" :tests="tests"></compliance_tests>
        </b-tab>
        <!-- Resourcing/Recruitment Information -->
        <b-tab title="Resourcing / Recruitment" lazy v-if="worker.rel_services.recruitment">
          <resourcing_recruitment :worker="worker"></resourcing_recruitment>
        </b-tab>
        <!-- Files -->
        <b-tab title="Files" lazy>
          <b-card-text>
            <files :files="files" :filesLoaded="files_loaded"></files>
          </b-card-text>
        </b-tab>
        <!-- Assignments -->
        <b-tab title="Assignments" lazy>
          <b-card-text>
            <assignments :worker="worker" :live_ass="live_assignments" :historic_ass="historic_assignments"></assignments>
          </b-card-text>
        </b-tab>
        <!-- Timesheets -->
        <b-tab title="Timesheets / Invoices" lazy @click="load_worker_timesheets_invoices">
          <b-card-text>
            <loadingCube v-if="timesheets_loading" :loadingMessage="'TIMESHEETS'"></loadingCube>
            <timesheets_invoices v-else :timesheets_invoices="timesheets_invoices"></timesheets_invoices>
          </b-card-text>
        </b-tab>
        <!-- Payslips / Statements -->
        <b-tab title="Payslips / Statements" lazy disabled>
          <b-card-text>
            <payslips_statements></payslips_statements>
          </b-card-text>
        </b-tab>
        <!-- Notes -->
        <!--        <b-tab title="Notes" lazy>-->
        <!--          <b-card-text>-->
        <!--            <notes :notes="notes" :notesLoaded="notes_loaded"></notes>-->
        <!--          </b-card-text>-->
        <!--        </b-tab>-->
        <b-tab title="Events & Tasks" lazy disabled>
          <b-card-text>
            <!--      <events_tasks></events_tasks>-->
          </b-card-text>
        </b-tab>
        <b-tab title="Communication" lazy disabled>
          <b-card-text>
            <!--      <communication></communication>-->
          </b-card-text>
        </b-tab>
        <!-- Tax/HMRC -->
        <b-tab title="Genius Tax" lazy v-if="crmType === 'payroll'">
          <b-card-text>
            <genius_tax :tax_hmrc="tax_hmrc" :tax_hmrc_loaded="tax_hmrc_loaded" :worker="worker" :tax_returns="tax_returns"></genius_tax>
          </b-card-text>
        </b-tab>
        <!-- Mileage -->
        <b-tab title="Mileage" lazy v-if="crmType === 'payroll'">
          <b-card-text>
            <mileage :tax_mileage="tax_mileage" :tax_mileage_loaded="tax_mileage_loaded"></mileage>
          </b-card-text>
        </b-tab>
        <!-- Declarations -->
        <b-tab title="Declarations" lazy>
          <b-card-text>
            <declarations :worker="worker" :files="files"></declarations>
          </b-card-text>
        </b-tab>
        <!-- Activity on Record -->
        <b-tab title="Activity on Record" lazy v-if="canViewLogs()">
          <b-card-text>
            <logs :logs="activity" :logsLoaded="activity_loaded"></logs>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import loadingCube from "loaders/record_loader";
import dashboard from "pages/workers/record/dashboard"
import personal_info from "pages/workers/record/personal_info"
import business_info from "pages/workers/record/business_info"
import cis_verification from "pages/workers/record/cis_verification";
import compliance_tests from "pages/workers/record/compliance_tests";
import resourcing_recruitment from "pages/workers/record/resourcing_recruitment"
import files from "pages/workers/record/files"
import assignments from "pages/workers/record/assignments";
import timesheets_invoices from "pages/workers/record/timesheets_invoices";
import payslips_statements from "pages/workers/record/payslips_statements";
import genius_tax from "pages/workers/record/genius_tax";
import mileage from "pages/workers/record/mileage";
import declarations from "pages/workers/record/declarations";
import logs from "pages/workers/record/logs"
// import events_tasks from "pages/workers/record/events_tasks";
// import communication from "pages/workers/record/communication";

export default {
  name: "worker_profile",
  components: {
    loadingCube,
    dashboard,
    personal_info,
    business_info,
    cis_verification,
    compliance_tests,
    resourcing_recruitment,
    files,
    assignments,
    timesheets_invoices,
    payslips_statements,
    // events_tasks,
    // communication,
    genius_tax,
    mileage,
    declarations,
    logs,
  },
  data() {
    return {
      worker_id: this.$store.state.workers.current_profile_worker_id,
      worker_profile_tabIndex: this.$store.state.workers.current_profile_tab_index,

      // worker export
      worker_export: false,

      // current signed in crm user details
      user: this.$store.state.auth.me,
      loading_worker: false,

      list_ac_export: {},
      list_p_export: {},
      list_t_export: {},

      worker: {},
      cis_status: {},

      emails: {},
      phones: {},
      addresses: {},
      banks: {},

      entity_test_loaded: false,
      tests: {},
      files_loaded: false,
      files: {},
      files_uploaded: [],
      file_order: ['id_1', 'id_2', 'contract', 'application', 'pe_ins_cert', 'pi_ins_cert', 'vat_cert', 'other_1', 'other_2'],
      notes_loaded: false,
      notes: {},
      assignments_loaded: false,
      live_assignments: {},
      historic_assignments: {},
      timesheets_loaded: false,
      timesheets_loading: false,
      timesheets_invoices: {},
      tax_hmrc_loaded: false,
      tax_hmrc: {},
      tax_mileage_loaded: false,
      tax_mileage: [],
      tax_returns: {},
      activity_loaded: false,
      activity: {},
      cis_loaded: false
    }
  },
  computed: {
    full_name() {
      return this.worker.person.first_name + ' ' + this.worker.person.surname;
    },

    in_ac_export() {

      // do not render Sage export buttons if worker not assigned or CRM is not V3
      // V3 does not use accounts to export
      if(!this.worker.is_assigned || this.crmType === 'recruitment') {
        return true;
      }

      return this.list_ac_export.find(ac => ac.worker_id === this.worker.id) !== undefined;
    },

    in_p_export() {

      // do not render Sage export buttons if worker not assigned
      if(!this.worker.is_assigned) {
        return true;
      }
      return this.list_p_export.find(p => p.worker_id === this.worker.id) !== undefined;
    },
    in_t_export() {
      return this.list_t_export.find(p => p.worker_id === this.worker.id) !== undefined;
    },

    entity_test_reload() {
      return this.$store.state.workers.reload_entity_test;
    },
    file_reload() {
      return this.$store.state.files.reload_files;
    },
    note_reload() {
      return this.$store.state.notes.reload_notes;
    },
    assignment_reload() {
      return this.$store.state.assignments.reload_assignments;
    },
    timesheet_reload() {

    },
    tax_hmrc_reload() {
      return this.$store.state.workers.reload_tax_hmrc;
    },
    tax_mileage_reload() {
      return this.$store.state.workers.reload_tax_mileage;
    },
    activity_reload() {
      return this.$store.state.logs.reload_logs;
    },
    cis_reload() {
      return this.$store.state.workers.reload_cis;
    },

    cis_status_class() {
      if (this.notEmptyObject(this.cis_status) && this.cis_status.cis_response !== null) {
        if (this.cis_status.cis_response.worker_status === 'unmatched') {
          return 'unmatched'
        }
        else if (this.cis_status.cis_response.worker_status === 'matched') {
          return 'matched'
        }
      }  else {
        return 'unmatched'
      }
    },
    cis_perc_class() {
      if (this.notEmptyObject(this.cis_status) && this.cis_status.cis_response !== null) {
        if (this.cis_status.cis_response.tax_treatment === 'gross') {
          return 'zero'
        }
        else if (this.cis_status.cis_response.tax_treatment === 'net') {
          return 'twenty'
        }
        else {
          return 'thirty'
        }
      }
    }
  },
  beforeMount() {
    let workerId = this.worker_id;
    const routeWorkerId = this.$route.query.worker_id || this.$route.query.worker_Id;

    if (routeWorkerId) {
      workerId = routeWorkerId;
      this.worker_id = workerId;
      this.worker_profile_tabIndex = null;
    }

    axios.get(this.crmApiPath + 'worker/' + workerId).then(worker => {
      this.worker = worker.data;
      let worker_promises = [];

      // CIS Status
      worker_promises.push(new Promise(resolve => {
        this.get_cis_status().then(() => resolve())
      }));

      // Emails
      worker_promises.push(new Promise(resolve => {
        axios.get(this.crmApiPath + 'contact_info/email/worker/' + workerId).then(emails => {
          this.emails = emails.data;
          resolve();
        })
      }))
      // Phones
      worker_promises.push(new Promise(resolve => {
        axios.get(this.crmApiPath + 'contact_info/phone/worker/' + workerId).then(phones => {
          this.phones = phones.data;
          resolve();
        })
      }))
      // Addresses
      worker_promises.push((new Promise(resolve => {
        axios.get(this.crmApiPath + 'contact_info/address/worker/' + workerId).then(addresses => {
          this.addresses = addresses.data;
          resolve();
        })
      })))
      // Finance Accounts Export List
      worker_promises.push((new Promise(resolve => {
        axios.get(this.crmApiPath + 'finance/export/worker/accounts/list_export').then(list_export => {
          this.list_ac_export = list_export.data;
          resolve();
        })
      })))
      // Finance Payroll Export List
      worker_promises.push((new Promise(resolve => {
        axios.get(this.crmApiPath + 'finance/export/worker/payroll/list_export').then(list_export => {
          this.list_p_export = list_export.data;
          resolve();
        })
      })))
      // Finance Payroll Export List
      worker_promises.push((new Promise(resolve => {
        axios.get(this.crmApiPath + 'finance/export/worker/tax/list_export').then(list_export => {
          this.list_t_export = list_export.data;
          resolve();
        })
      })))
      // Banks
      worker_promises.push(new Promise(resolve => {
        axios.get(this.crmApiPath + 'worker/bank/index/' + workerId).then(banks => {
          this.banks = banks.data;
          resolve();
        })
      }))
      // Notes
      worker_promises.push(new Promise(resolve => {
        this.get_worker_notes().then(() => resolve());
      }))
      // logs
      worker_promises.push(new Promise(resolve => {
        this.get_worker_logs().then(() => resolve());
      }))
      // Tax Mileages
      worker_promises.push(new Promise(resolve => {
        this.get_worker_tax_mileage().then(() => resolve());
      }))
      // tax genius
      worker_promises.push(new Promise(resolve => {
        this.get_worker_tax_hmrc().then(() => resolve())
      }))
      // tax mileage
      worker_promises.push(new Promise(resolve => {
        this.get_worker_tax_mileage().then(() => resolve())
      }))
      // tax returns
      worker_promises.push(new Promise(resolve => {
        this.get_worker_tax_returns().then(() => resolve())
      }))
      // Compliance tests
      worker_promises.push(new Promise(resolve => {
        this.get_worker_compliance_tests().then(() => resolve());
      }))
      // Assignments (Live)
      worker_promises.push(new Promise(resolve => {
        this.get_live_worker_assignments().then(() => resolve());
      }))
      // Assignments (Historic)
      worker_promises.push(new Promise(resolve => {
        this.get_historic_worker_assignments().then(() => resolve());
      }))
      // Files
      worker_promises.push(new Promise(resolve => {
        this.get_worker_files().then(() => resolve());
      }))
      Promise.all(worker_promises).then(() => {
        this.setInitialTabFromRoute();
        this.loading_worker = true;
        this.$nextTick(() => this.load_worker_timesheets_invoices_if_active());
      });
    });
  },
  watch: {
    cis_reload(val) {
      if (val) {
        this.cis_loaded = false;
        this.get_cis_status();
      }
    },
    entity_test_reload(val) {
      if (val === true) {
        this.entity_test_loaded = false;
        this.get_worker_compliance_tests();
      }
    },
    note_reload(val) {
      if (val === true) {
        this.notes_loaded = false;
        this.get_worker_notes()
      }
    },
    file_reload(val) {
      // console.log(val + ' : file reload')
      if (val === true) {
        this.files_loaded = false;
        this.files_uploaded = [];
        this.get_worker_files()
      }
    },
    activity_reload(val) {
      if (val === true) {
        this.activity_loaded = false;
        this.get_worker_logs()
      }
    },
    tax_hmrc_reload(val) {
      if (val === true) {
        this.tax_hmrc_loaded = false;
        this.$nextTick(() => {
          this.get_worker_tax_hmrc().then(() => {
            this.get_worker_tax_returns().then(() => this.tax_hmrc_loaded = true);
          });
        });

      }
    },
    tax_mileage_reload(val) {
      if (val === true) {
        this.tax_hmrc_loaded = false;
        this.get_worker_tax_mileage();
        this.get_worker_tax_returns();
      }
    },
    assignment_reload(val) {
      if (val) {
        this.assignments_loaded = false;
        this.get_live_worker_assignments().then(() => {
          this.get_historic_worker_assignments();
        });
      }
    },
    worker_profile_tabIndex(tab) {
      this.$store.commit('SET_WORKER_TAB_INDEX', tab);
      this.load_worker_timesheets_invoices_if_active();
    }
  },
  methods: {
    canViewLogs(){
      return this.$store.state.auth.me.permissions.includes('sunset_note_stats_restricted');
    },
    setInitialTabFromRoute() {
      const tab = this.$route.query.tab;

      if (!tab) {
        return;
      }

      const tabs = this.worker_profile_tabs();

      const index = tabs.indexOf(tab);

      if (index !== -1) {
        this.worker_profile_tabIndex = index;
      }
    },
    update_tab_index(tab) {
      this.worker_profile_tabIndex = tab;
    },
    worker_profile_tabs() {
      const tabs = [
        'dashboard',
        'personal',
      ];

      const employmentTypeId = this.worker && this.worker.rel_company_info
          ? this.worker.rel_company_info.employment_type_id
          : null;

      if (employmentTypeId !== null && employmentTypeId !== 33) {
        tabs.push('business');
        tabs.push('cis');
        tabs.push('compliance');
      }

      if (this.worker && this.worker.rel_services && this.worker.rel_services.recruitment) {
        tabs.push('resourcing');
      }

      tabs.push('files');
      tabs.push('assignments');
      tabs.push('timesheets');
      tabs.push('payslips');
      tabs.push('events');
      tabs.push('communication');

      if (this.crmType === 'payroll') {
        tabs.push('genius_tax');
        tabs.push('mileage');
      }

      tabs.push('declarations');
      tabs.push('activity');

      return tabs;
    },
    load_worker_timesheets_invoices_if_active() {
      if (!this.worker || !this.worker.id) {
        return;
      }

      if (this.worker_profile_tabIndex === null || this.worker_profile_tabIndex === undefined) {
        return;
      }

      const timesheetsTabIndex = this.worker_profile_tabs().indexOf('timesheets');

      if (timesheetsTabIndex !== -1 && Number(this.worker_profile_tabIndex) === timesheetsTabIndex) {
        this.load_worker_timesheets_invoices();
      }
    },
    load_worker_timesheets_invoices() {
      if (!this.worker_id) {
        return;
      }

      if (this.timesheets_loaded || this.timesheets_loading) {
        return;
      }

      this.get_worker_timesheets_invoices();
    },
    /**
     * Get worker information
     */
    get_worker_compliance_tests() {
      return axios.get(this.crmApiPath + 'worker/compliance_test/worker/' + this.worker_id + '/index').then(worker_tests => {
        if (worker_tests.data !== '') {
          this.tests = worker_tests.data;
        }
        this.entity_test_loaded = true;
      })
    },
    get_worker_files() {
      return axios.get(this.crmApiPath + 'file/worker/' + this.worker_id).then(worker_files => {
        this.files = this.mapArrayOrder(worker_files.data, this.file_order, 'type');

        this.files.sort(function (a, b) {
          let file_a = a.type.file_type.toLowerCase(), file_b = b.type.file_type.toLowerCase();
          if (file_a < file_b) {
            return -1
          }
          if (file_a > file_b) {
            return 1
          }
        });

        this.files_loaded = true;
        this.$nextTick(() => worker_files.data.forEach(file => this.files_uploaded.push(file.type.id)));
      });
    },
    get_worker_notes() {
      return axios.get(this.crmApiPath + 'sunset/notes/worker/' + this.worker_id).then(worker_notes => {
        this.notes = worker_notes.data;
        this.notes_loaded = true;
      });
    },
    get_live_worker_assignments() {
      return axios.get(this.crmApiPath + 'assignments/worker/current_assignments/' + this.worker_id).then(live_ass => {
        this.live_assignments = live_ass.data;
      })
    },
    get_historic_worker_assignments() {
      return axios.get(this.crmApiPath + 'assignments/worker/historic_assignments/' + this.worker_id).then(historic_ass => {
        this.historic_assignments = historic_ass.data;
        this.assignments_loaded = true;
      })
    },
    get_worker_timesheets_invoices() {
      this.timesheets_loading = true;

      return axios.get(this.crmApiPath + 'worker/timesheets_invoices/' + this.worker_id).then(timesheets_invoices => {
        this.timesheets_invoices = timesheets_invoices.data;
        this.timesheets_loaded = true;
        this.timesheets_loading = false;
      }).catch(error => {
        this.timesheets_loading = false;
        throw error;
      })
    },
    get_worker_tax_hmrc() {
      return axios.get(this.crmApiPath + 'worker/tax_genius/worker/' + this.worker_id).then(genius_tax => {
        this.tax_hmrc = genius_tax.data;
      });
    },
    get_worker_tax_mileage() {
      return axios.get(this.crmApiPath + 'worker/tax_mileage/worker/' + this.worker_id).then(tax_mileage => {
        if (tax_mileage.data !== '') {
          this.tax_mileage = tax_mileage.data;
        }
        this.tax_hmrc_loaded = true;
      });
    },
    get_worker_tax_returns() {
      return axios.get(this.crmApiPath + 'worker/tax_returns/worker/' + this.worker_id).then(tax_returns => {
        if (tax_returns.data !== '') {
          this.tax_returns = tax_returns.data;
        }
        this.tax_hmrc_loaded = true;
      });
    },

    get_cis_status() {
      /**
       * Return hmrc_cis_infos Record
       * Check if there is a hmrc_cis_infos record for this worker -> if not then create
       */
      let utr_number = null, ni_number = null, initial_first_name = null, surname = null, trading_name = null, crn = null;
      // if employment type is 'Limited Company' ELSE 'sole trader'
      if (this.worker.rel_company_info.employment_type_id === 32) {
        utr_number = this.worker.rel_company_info.company_utr_number;
        crn = this.worker.rel_company_info.company_ltd_reg_number;
        trading_name = this.worker.rel_company_info.company_trading_name
      }
      else {
        utr_number = this.worker.rel_profile.personal_utr_number;
        ni_number = this.worker.rel_profile.ni_number;
        initial_first_name = this.worker.person.first_name;
        surname = this.worker.person.surname;
      }
      return axios.get(this.crmApiPath + 'hmrc/cis/status/info/' + this.worker.id, {
        params: {
          utr_number: utr_number,
          ni_number: ni_number,
          employment_type_id: this.worker.rel_company_info.employment_type_id,
          initial_first_name: initial_first_name,
          surname: surname,
          trading_name: trading_name,
          crn: crn
        }
      }).then(res => {
        this.cis_status = res.data;
        this.cis_loaded = true;
      })
    },

    get_worker_logs() {
      return axios.get(this.crmApiPath + 'sunset/logs/worker/' + this.worker_id).then(worker_logs => {
        this.activity = worker_logs.data;
        this.activity_loaded = true;
      });
    },

    createEmail() {
      this.$router.push('/email/create');
    },
    createEvent() {
      this.$router.push('/calendar/event/create');
    },
    createTask() {
      this.$router.push('/tasks/create');
    },
    /**
     * Quick button functions
     */
    export_worker() {
      this.worker_export = true;
      axios.post(this.crmApiPath + 'worker/export/' + this.worker.id).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        let name  = this.worker.person.first_name.replace(' ', '-').toLowerCase() + '_' +
            this.worker.person.surname.replace(' ', '-').toLowerCase();
        link.setAttribute('download', 'worker_export_' + name
            + '_' + this.$moment.utc().format('DD-MM-YYYY') + '.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.$nextTick(() => this.worker_export = false)
      })
    },
    add_to_finance_export_accounts() {
      axios.post(this.crmApiPath + 'finance/export/worker/accounts', {
        worker_id: this.worker.id,
        user_id: this.$store.state.auth.me.id,
        exported: false,
      }).then(ac_export => {
        this.list_ac_export = ac_export.data.data;
        this.$bvToast.toast('Worker added to accounts export list.', {
          title: 'Success',
          variant: 'success',
          solid: true,
        });
      }).catch(error => {
        this.$bvToast.toast(error.response.data.error, {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      });
    },
    add_to_finance_export_payroll() {
      axios.post(this.crmApiPath + 'finance/export/worker/payroll', {
        worker_id: this.worker.id,
        user_id: this.$store.state.auth.me.id,
        exported: false,
      }).then(p_export => {
        this.list_p_export = p_export.data.data;
        this.$bvToast.toast('Worker added to payroll export list.', {
          title: 'Success',
          variant: 'success',
          solid: true,
        });
      }).catch(error => {
        this.$bvToast.toast(error.response.data.error, {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      });
    },
    add_to_finance_export_tax() {
      axios.post(this.crmApiPath + 'finance/export/worker/tax', {
        worker_id: this.worker.id,
        user_id: this.$store.state.auth.me.id,
        exported: false,
      }).then(p_export => {
        this.list_t_export = p_export.data;
        this.$bvToast.toast('Worker added to tax export list.', {
          title: 'Success',
          variant: 'success',
          solid: true,
        });
      }).catch(error => {
        this.$bvToast.toast('Something went wrong', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      });
    },
    show_edit_worker() {
      this.$store.commit('CURRENT_EDIT_WORKER_ID', this.worker_id);
      this.$nextTick(() => {
        this.$tabs.close({
          path: this.$router.currentRoute.fullPath,
          to: '/workers/edit'
        });
        this.$tabs.refresh('/workers/edit', true);
      });
    },
    delete_worker() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Delete Worker</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you wish to delete ' + this.full_name +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$store.commit('SET_DELETE_WORKER_ID', this.worker.id);

              this.$snotify.remove(toast.id);
              axios.delete(this.crmApiPath + 'worker/' + this.worker.id, {
                params: {
                  // Set log values for creating the worker (current crm user)
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id
                }
              }).then(() => {
                this.$snotify.success('Worker Deleted');
                this.$bus.$emit('table::reload', {table: 'all_workers', type: 'delete'});
                this.$nextTick(() => {
                  this.$tabs.close({
                    path: this.$router.currentRoute.fullPath,
                    to: '/workers/all'
                  });
                })
              });
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    add_note_modal() {
      this.$store.commit('SHOW_ADD_NOTE_MODAL', {
        id: this.worker.id,
        name: this.full_name,
        type: 'worker',
        contacts: null
      });
      this.$store.state.notes.add_modal = true;
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_note_modal'));
    },
    add_files_modal() {
      this.$store.commit('SHOW_ADD_FILE_MODAL', {
        id: this.worker.id,
        name: this.full_name,
        employment_type: this.worker.rel_company_info.employment_type,
        type: 'worker',
        vat_registered: this.worker.rel_company_info.vat_registered,
        uploaded_files: this.files_uploaded,
        nationality: this.worker.person.nationality,
      });
      this.$store.state.files.add_modal = true;
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'upload_file_modal'));
    }
  }
}
</script>

<style lang="scss" scoped>
.cis_status {
  color:         $white;
  padding:       5px;
  border-radius: $border_radius_2;

  .cs_head {
    text-align:  center;
    font-weight: bold;
  }

  .cs_body {
    text-align: center;
    padding:    5px 0;

    .perc {
      &.zero, &.twenty {
        background: $green;
      }

      &.thirty {
        background: $red;
      }
    }
  }

  &.matched {
    background: $green;
  }

  &.unmatched {
    background: $red;
  }
}
</style>
